/*
**  slideshow -- Observe and Control Slideshow Applications
**  Copyright (c) 2014-2015 Ralf S. Engelschall <http://engelschall.com>
**
**  This Source Code Form is subject to the terms of the Mozilla Public
**  License (MPL), version 2.0. If a copy of the MPL was not distributed
**  with this file, You can obtain one at http://mozilla.org/MPL/2.0/.
**
**  File:     slideshow.js
**  Purpose:  Application Programming Interface (API)
**  Language: Node/JavaScript
*/

/* global require: false */
/* global module: false */

var connector = require("./connector");
var pathSetFront;

/*  the slideshow API constructor  */
var slideshow = function (application) {
    this.cleanArgs();
    this.connector = new connector(application);
    this.lockState = false;
    this.exporting = false;
    this.onInfo = this.onInfo.bind(this);
    this.onError = this.onError.bind(this);
    this.onExported = this.onExported.bind(this);

    var path = window.require('path');
    pathSetFront = path.join(window.__dirname, ".." ,"appleScripts/setFront.ps1");
    pathSetFront = pathSetFront.replace(new RegExp("/", 'g'), "\\");
    pathSetFront = encodeURIComponent(pathSetFront);
    console.log('pathSetFront ' + pathSetFront)
};

/*  the slideshow API methods  */
slideshow.prototype = {
    request: function (request) {
        return this.connector.request(request);
    },
    end: function () {
        this.connector.end();
    },
    "cleanArgs": function(){ this.cmdCtrl = ""; this.argCmd = "";},
    "setErrorCB": function( fn ){
            this.connector.callbackError = this.onError;
            this.errorCB = fn;
        },
    "onError":   function ( data ) {
                    if( data.indexOf('"cmd": "INFO"') >= 0){
                        this.lockState = false;
                    }
                   this.errorCB();
                },
    "setStateCB":   function(fn, timeScriptWSH){
                        console.log('timeScriptWSH ' + timeScriptWSH)
                        this.connector.callbackStat = fn;
                        var tempRef = this;
                        setInterval( function(){ tempRef.stat() }, timeScriptWSH);
                    },
    "stat":   function () {
                        //console.log('entraaa ' + !this.connector.stateReceived)
                        if( this.lockState || !this.connector.stateReceived ){
                            if( this.exporting ){
                                return this.connector.request({ command: "CONT_EXPORT " });
                            }
                            return;
                        }

                        this.connector.stateReceived = false;
                        this.connector.request({ command: "STAT " + this.cmdCtrl + " " + this.argCmd });
                        if( this.cmdCtrl != "" ){
                            this.cleanArgs();
                        }
                },
    "exportToPDF":function ( name, fn) {
                    return this.exportSlides( name, fn );
                },
    "exportSlides":function ( name, fn, startedFromAuditorium) {
                    this.lockState = true;
                    this.cbExport = fn;
                    this.connector.callbackExport = this.onExported;
                    console.log('call ato export')
                    return this.connector.request({ command: "EXPORT " + name + " " + (startedFromAuditorium ? "1" : "0")});
                },
    "onExported": function (jsonResponse) {
                    if( jsonResponse.cmd == "EXPORT"){
                        this.exporting = true;
                    }
                    else{
                        console.log('exporting', jsonResponse.response.exporting)
                        if( !jsonResponse.response.exporting ){
                            this.lockState = false;
                            this.exporting = false;
                        }
                    }

                    this.cbExport(jsonResponse);
                },
    "info":   function (fn) {
                    this.lockState = true;
                    this.cbInfo = fn;
                    this.connector.callbackInfo = this.onInfo;
                    return this.connector.request({ command: "INFO" });
                },
    "onInfo":   function (jsonResponse) {
                    this.lockState = false;
                    this.cbInfo(jsonResponse);

                },
    "getTempPath": function (fn) { this.connector.callbackTempPath = fn;return this.connector.request({ command: "TEMPPATH" }); },
    "imgToglea": function(fn){ this.connector.callbackImgToglea = fn;return this.connector.request({ command: "IMGTOGLEA" }); },
    "insertSlide": function(path, id, w, h, pptName, comment ){ console.log("to testo: " + "INSSLIDE " + path + " " + id + " " + w + " " + h + " " + pptName + " " + comment);return this.connector.request({ command: "INSSLIDE " + path + " " + id + " " + w + " " + h + " " + pptName + " " + comment }); },
    "boot":   function ()   { return this.connector.request({ command: "BOOT"       }); },
    "quit":   function ()   { return this.connector.request({ command: "QUIT"       }); },
    "open":   function (fn) { return this.connector.request({ command: "OPEN " + fn }); },
    "close":  function ()   { return this.connector.request({ command: "CLOSE"      }); },
    "pause":  function ()   { return this.connector.request({ command: "PAUSE"      }); },
    "resume": function ()   { return this.connector.request({ command: "RESUME"     }); },
    "activate": function ()   { return this.connector.request({ command: "ACTIVATE " + pathSetFront     }); },
    "first":  function ()   { return this.connector.request({ command: "FIRST"      }); },
    "last":   function ()   { return this.connector.request({ command: "LAST"       }); },
    "goto":   function (sn) { return this.connector.request({ command: "GOTO " + sn }); },
    /*"prev":   function ()   { return this.connector.request({ command: "PREV"       }); },
    "next":   function ()   { return this.connector.request({ command: "NEXT"       }); },
    "start":  function ( name ){ return this.connector.request({ command: "START " + name }); },
    "stop":   function ()   { return this.connector.request({ command: "STOP"       }); }*/
    "visibleImgs":   function ()   { this.cmdCtrl = "VISIBLE" },
    "prev":   function ()   { this.cmdCtrl = "PREV" },
    "next":   function ()   { this.cmdCtrl = "NEXT" },
    "start":  function ( name, countScreens ){ this.cmdCtrl = "START"; this.argCmd = name + " " + countScreens; },
    "stop":   function ()   { this.cmdCtrl = "STOP"  }
};

/*  export the API  */
module.exports = slideshow;




// WEBPACK FOOTER //
// ./src/containers/platforms/electron/js/powerpoint/mac/api/slideshow-api.js